<template>
  <base-list-table :data="data" :structure="structure" :refreshFunction="refreshPage" />
</template>

<script>
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';

  export default {
    components: {},
    setup() {
      const route = useRoute();
      const store = useStore();
      const vehicleId = { device: route.params.id };

      function refreshPage(payload) {
        store.dispatch('getRentals', {
          ...payload,
          ...vehicleId,
        });
      }

      const rentals = computed(() => store.getters.rentals);

      const structure = {
        title: 'Lista Noleggi',
        data: [
          {
            title: 'user.title',
            
            fields: [
              {
                placeholder: '@',
                name: 'user',
                subName: 'id',
                class: 'text-primary-400',
              },
              {
                name: 'user',
                subName: 'name',
              },
              {
                name: 'user',
                subName: 'email',
              },
            ],
            link: {
              idField: 'id',
              subField: 'user',
              path: '/user/users/:id',
            },
            span: 1,
          },
          {
            title: 'Mezzo',
            fields: [
              {
                placeholder: 'Tipo: ',
                name: 'device',
                subName: 'type',
              },
              {
                placeholder: '@',
                class: 'text-primary-400',
                name: 'device',
                subName: 'id',
              },
              {
                name: 'device',
                subName: 'plate',
              },
            ],
            link: {
              idField: 'id',
              subField: 'device',
              type: 'vehicle',
              path: '/vehicle/:id/general',
            },
            span: 1,
          },
          {
            title: 'Gestore',
            fields: [
              {
                placeholder: '@',
                name: 'manager',
                subName: 'id',
                class: 'text-primary-400',
              },
              {
                name: 'manager',
                subName: 'name',
              },
            ],
            span: 1,
            link: {
              idField: 'id',
              subField: 'manager',
              path: '/sharing/managers/:id',
            },
          },
          {
            title: 'Inizio noleggio',
            field: 'start_timestamp',
            format: 'datetime',
            span: 1,
          },
          {
            title: 'Fine noleggio',
            field: 'end_timestamp',
            format: 'datetime',
            span: 1,
          },
          {
            title: 'Costo',
            field: 'total_amount',
            format: 'euro',
            span: 1,
          },
        ],
      };
      return {
        data: rentals,
        structure,
        refreshPage,
      };
    },
  };
</script>

<style></style>
